"use client"

import { AlignVerticalJustifyCenter } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignVerticalJustifyCenterIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignVerticalJustifyCenterIcon = component(Icon)({
  as: AlignVerticalJustifyCenter,
})
